import { FloatingCartButton } from "@/components/cart/FloatingCartButton";
import { HeaderSticky } from "@/components/header-sticky";
import { CategoryHero } from "@/components/home/CategoryHero";
import { CategoryEmptyState, CategoryItemGrid } from "@/components/home/CategoryItemGrid";
import { BackButton } from "@/components/navigations";
import { SearchEmpty } from "@/components/ui";
import { Category, ItemOffer } from "@/types";

export function CategoryContent({
  category,
  handleImageClick,
  imageRef,
  scrollYPosition,
  setShowSearch,
  showSearch,
  itemsFilter,
  setItemsFilter,
  filteredItemOffers,
  handleModalClose,
  handleItemClick,
  clearFilterItens,
}: {
  category: Category
  handleImageClick: () => void
  imageRef: React.RefObject<HTMLDivElement>
  scrollYPosition: number
  setShowSearch: (show: boolean) => void
  showSearch: boolean
  itemsFilter: string
  setItemsFilter: (filter: string) => void
  filteredItemOffers: ItemOffer[]
  handleModalClose: () => void
  handleItemClick: (itemId: string) => void
  clearFilterItens: () => void
}) {

  if (filteredItemOffers.length === 0 && itemsFilter.length === 0) {
    return <CategoryEmptyState onBack={handleModalClose} />
  }

  return (
    <>
      <HeaderSticky
        scrollYPosition={scrollYPosition}
        name={category.name}
        setShowSearch={setShowSearch}
        showSearch={showSearch}
        itemsFilter={itemsFilter}
        setItemsFilter={setItemsFilter}
        showIconSearch={itemsFilter.length > 0 || filteredItemOffers.length > 8}
        reactComponent={<BackButton label="Voltar" onClick={handleModalClose} />}
      />
      <div className="mx-auto w-full max-w-shell">
        <CategoryHero category={category} onZoom={handleImageClick} imageRef={imageRef} />
        <CategoryItemGrid
          offers={filteredItemOffers}
          onItemClick={handleItemClick}
          empty={
            <SearchEmpty
              headingLevel={3}
              className="col-span-full"
              title="Nenhum produto encontrado"
              description={`Não encontramos produtos com o termo "${itemsFilter}".`}
              onClear={clearFilterItens}
            />
          }
        />
      </div>
      <FloatingCartButton />
    </>
  )
}
